import React, { Component } from "react";
import {
    Pagination,
    PaginationItem,
    PaginationLink
} from "reactstrap";


class TYPagination extends Component{
    constructor(props){
        super(props);

        this.state = {
            page: this.props.page
        };
    }

    setPage = i => this.setState({page: i}, () => this.props.onPageChanged(i));

    render(){
        let nb_pages_shown = this.props.total_pages;
        if(nb_pages_shown > this.props.max_around*2 + 1)
            nb_pages_shown = this.props.max_around*2 + 1;
        let page = this.props.page + 1;
        let more_before = false;
        let more_after = false;
        let offset = 1;

        if(page > 1 && (page - 1) - this.props.max_around > 0){
            more_before = true;
            offset = page - this.props.max_around;
        }
        if(page + this.props.max_around < this.props.total_pages)
            more_after = true;

        return (
            <Pagination>
            {
                page > 1 ?
                    <PaginationItem>
                        <PaginationLink onClick={() => this.setPage(1)}>&laquo;</PaginationLink>
                    </PaginationItem>
                    :
                    ""
            }
            {
                page > 1 ?
                    <PaginationItem>
                        <PaginationLink onClick={() => this.setPage(page-1)}>&lsaquo;</PaginationLink>
                    </PaginationItem>
                    :
                    ""
            }
            {
                [...Array(nb_pages_shown)].map((_, i) => {
                    return i + offset <= this.props.total_pages ? <PaginationItem key={"pagination-" + i} active={i+offset === page ? true : false}>
                        <PaginationLink onClick={() => {this.setPage(i+offset);}}>
                        { i === 0 && more_before ? "... " : ""}
                        { i + offset }
                        { i + 1 === nb_pages_shown && more_after ? " ..." : ""}
                        </PaginationLink>
                    </PaginationItem> : null;
                })
            }
            {
                this.state.page < (this.props.total_pages - 1) ?
                    <PaginationItem>
                        <PaginationLink onClick={() => this.setPage(page+1)}>&rsaquo;</PaginationLink>
                    </PaginationItem>
                    :
                    ""
            }
            {
                this.state.page < (this.props.total_pages - 1) ?
                    <PaginationItem>
                        <PaginationLink onClick={() => this.setPage(this.props.total_pages)}>&raquo;</PaginationLink>
                    </PaginationItem>
                    :
                    ""
            }
            </Pagination>
        );
    }
}

TYPagination.defaultProps = {
    page: 1,
    per_page: 25,
    total_pages: 1,
    max_around: 2,
    onPageChanged: () => {}
};

export default TYPagination;



// WEBPACK FOOTER //
// ./src/components/TYPagination.js